export enum ImeScorecardSectionsEnum {
    CasualtyScore = 1,
    TreatmentScore= 2,
    WorkScore = 3,
}